// const TLD = 'com'
import { API_URL, MEDIA_URL, SITE_PUBLIC_DOMAIN } from '@/config'

// @TODO: This file is a bit of a mess. It contains a mix of constants, config values, and helper functions. It should be refactored to separate these concerns.
// consider moving to @/config/index.js and exporting as named exports instead of a single object. This would allow for better tree shaking and easier imports.
export const constants = Object.freeze({
  // URLS
  API_URL: API_URL,
  MEDIA_URL: MEDIA_URL,
  SITE_PUBLIC_DOMAIN: SITE_PUBLIC_DOMAIN,

  IRI_PREFIX: '/api',
  get IRI_USERS () { return this.IRI_PREFIX + '/users/' },
  get IRI_EVENTS () { return this.IRI_PREFIX + '/events/' },
  get IRI_EVENT_WELCOMES () { return this.IRI_PREFIX + '/event_welcomes/' },
  get IRI_PARTICIPANTS () { return this.IRI_PREFIX + '/participants/' },
  get IRI_EVENT_GROUPS () { return this.IRI_PREFIX + '/event_groups/' },
  get IRI_SPORTS () { return this.IRI_PREFIX + '/sports/' },
  // get IRI_ () { return this.IRI_PREFIX + '//'; },

  // SPORTS
  LOOKUP_EXCLUDE: ['Multi-Sport','Other'],

  // CONTENT TYPES
  CONTENT_TYPE_PAGE: 'page',
  CONTENT_TYPE_POST: 'post',
  CONTENT_TYPE_HAPPENING_NOW: 'happening_post',

  // MESSAGE TYPES
  MESSAGE_TYPE_EVENT_GROUP: 'EVENT_GROUP',
  MESSAGE_TYPE_EVENT: 'EVENT',
  MESSAGE_TYPE_MEMBER: 'MEMBER',
  MESSAGE_TYPE_DIRECTOR: 'DIRECTOR',
  
  // USER ROLES
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_COACH: 'ROLE_COACH',

  // INVOICES
  TID_FREE: 'FREE',
  TAX_ITEM_LABEL: 'Tax',

  // MARKETING
  OTHER_SOURCE_ID: "/api/marketing_sources/8",

  LIST_DEFAULT_ITEMS_PER_PAGE: 30,

  // REVENUE REPORT SURVEY
  SURVEY_MONTHS: [1,4,7,10],
})